__turbopack_context__.v({
  "content": "ngeKJW_content",
  "indicator": "ngeKJW_indicator",
  "list": "ngeKJW_list",
  "tabs": "ngeKJW_tabs",
  "trigger": "ngeKJW_trigger",
});
